import { FormField } from '../form-fields/FormField';
import { CardSelect, CardOption } from '../form-fields/CardSelect';
import { TextInput } from '../form-fields/TextInput';
import { howFoundUsOptions } from '../form-data/formOptions';
import {
  Mail,
  Link,
  Search,
  Users,
  Megaphone,
  MessageSquare,
  Calendar,
  BookOpen,
  Share2,
  MoreHorizontal,
} from 'lucide-react';
import { UserInfoFormData } from '../hooks/useUserInfoForm';

interface Step2HowFoundUsProps {
  formData: UserInfoFormData;
  loading: boolean;
  updateField: (field: keyof UserInfoFormData, value: string) => void;
  wiggleFields: Set<string>;
}

export function Step2HowFoundUs({
  formData,
  loading,
  updateField,
  wiggleFields,
}: Step2HowFoundUsProps) {
  const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
    'Invited by Jua team': Mail,
    'Direct (typed URL)': Link,
    'Google Search': Search,
    LinkedIn: Users,
    'Twitter/X': MessageSquare,
    Facebook: Users,
    Reddit: MessageSquare,
    'Word of mouth': Megaphone,
    'Conference/Event': Calendar,
    'Blog/Article': BookOpen,
    Other: MoreHorizontal,
  };

  const cardOptions: CardOption[] = howFoundUsOptions.map((o) => ({
    value: o.value,
    label: o.label,
    icon: iconMap[o.label] || Share2,
  }));

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h2 className="text-lg font-medium text-theme-light-text-primary dark:text-theme-dark-text-primary mb-1">
          How did you find us?
        </h2>
        <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary">
          This helps us improve our experience
        </p>
      </div>

      <div className="space-y-4">
        <div className={wiggleFields.has('howFoundUs') ? 'wiggle-animation' : ''}>
          <FormField label="Select one" htmlFor="howFoundUs" required>
            <div className="space-y-2">
              <CardSelect
                options={cardOptions}
                value={formData.howFoundUs}
                onChange={(val) => updateField('howFoundUs', val)}
                disabled={loading}
                columns="3"
              />
              {formData.howFoundUs === 'Other' && (
                <FormField
                  label="Please specify (optional)"
                  htmlFor="howFoundUsOther"
                  helpText="You can leave this blank if you prefer not to specify"
                >
                  <TextInput
                    id="howFoundUsOther"
                    name="howFoundUsOther"
                    placeholder="Please specify how you found us"
                    value={formData.howFoundUsOther}
                    onChange={(e) => updateField('howFoundUsOther', e.target.value)}
                    disabled={loading}
                  />
                </FormField>
              )}
            </div>
          </FormField>
        </div>
      </div>
    </div>
  );
}
